import { NextRequest, NextResponse } from 'next/server';

const ON_PREM_API_URL =
  process.env.ON_PREM_API_URL || 'http://111.235.82.64:2024/api/deviceregister';

type DeviceRegisterBody = {
  DeviceID?: string;
  DeviceModel?: string;
  email?: string;
  LastName?: string;
  FirstName?: string;
  MiddleName?: string;
  BirthDate?: string;
  CompleteAddress?: string;
  Password?: string;
  MobileNo?: string;
  IsActive?: boolean;
  selfie_base64?: string;
  government_id_base64?: string;
};

export async function POST(req: NextRequest) {
  try {
    const body = (await req.json()) as DeviceRegisterBody;

    if (!body.DeviceID?.trim() || !body.email?.trim()) {
      return NextResponse.json(
        { error: 'Missing required fields: DeviceID, email' },
        { status: 400 },
      );
    }

    const resp = await fetch(ON_PREM_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    const text = await resp.text();
    let data: unknown;
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }

    return NextResponse.json(data, { status: resp.status });
  } catch (err) {
    console.error('Error forwarding to on-prem deviceregister API', err);
    return NextResponse.json(
      { error: 'Internal server error while contacting registration service' },
      { status: 500 },
    );
  }
}

